var __WEBPACK_NAMESPACE_OBJECT__ = require("formiojs/components/currency/Currency.form");